/* eslint-disable react/destructuring-assignment */
import React from "react";
import { useParams } from "react-router-dom";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import { useSelector } from "react-redux";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import FormattedNumber from "pages/_components/FormattedNumber";
import FormmatedText from "pages/_components/CustomText/_components/FormmatedText";
import { bool } from "prop-types";
import getCellPlacement from "../../../../util/helpers/table";

const DataDetailDiscounts = ({ isDesktop }) => {
    const { echeqDocuments } = useSelector((_state) => _state.discounts);

    const { echeqNumber } = useParams();

    const dataEcheq = echeqDocuments?.find((item) => item.echeqNumber === echeqNumber);
    const receivedBy = dataEcheq?.receivedBy.split("\n") || ["", ""];
    const receivedByCuit = receivedBy[0];
    const receivedByName = receivedBy[1];
    const getCellProps = (row, col) => getCellPlacement(row, col, { isDesktop });

    return (
        <>
            <GridTable className="debin-credin-list">
                <GridTable.Container columns={3} rows={3}>
                    <GridTable.Data columnStart={1} rowStart={1} columnWidth={1}>
                        <CustomData
                            titleText="detail.echeq.recibedTo"
                            titleTextType="I18N"
                            valueText={
                                <>
                                    <FormmatedText text={receivedByCuit} />
                                    <br />
                                    <FormmatedText text={receivedByName} />
                                </>
                            }
                        />
                    </GridTable.Data>
                    <GridTable.Data columnWidth={1} {...getCellProps(1, 2)}>
                        <CustomData
                            titleText="detail.echeq.emitted"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={dataEcheq?.dateEmitted} format="DD/MM/YYYY" />}
                            valueTextType="TEXT"
                        />
                    </GridTable.Data>
                    <GridTable.Data columnWidth={1} {...getCellProps(1, 3)}>
                        <CustomData
                            titleText="detail.echeq.expirate"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={dataEcheq?.echeqPayDay} format="DD/MM/YYYY" />}
                            valueTextType="TEXT"
                            dateFormat="dd/MM/yyyy"
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 4} columnWidth={1}>
                        <CustomData
                            titleText="detail.echeq.amount"
                            titleTextType="I18N"
                            valueText={
                                <FormattedAmount
                                    currency={dataEcheq?.amount.currency}
                                    quantity={dataEcheq?.amount.quantity}
                                />
                            }
                            valueTextType="TEXT"
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 2 : 5} columnWidth={1}>
                        <CustomData
                            titleText="detail.echeq.discountedAmount"
                            titleTextType="I18N"
                            valueTextType="TEXT"
                            valueText={
                                <FormattedAmount
                                    currency={dataEcheq?.effectiveAmount.currency}
                                    quantity={dataEcheq?.effectiveAmount.quantity}
                                />
                            }
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 2 : 6} columnWidth={1}>
                        <CustomData
                            titleText="detail.echeq.rate"
                            titleTextType="I18N"
                            valueTextType="TEXT"
                            valueText={
                                <FormattedNumber fixedDecimalScale suffix=" %">
                                    {dataEcheq?.taxes.rate}
                                </FormattedNumber>
                            }
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 3 : 7} columnWidth={1}>
                        <CustomData
                            titleText="detail.echeq.interest"
                            titleTextType="I18N"
                            valueTextType="TEXT"
                            valueText={<FormattedAmount currency="ARS" quantity={dataEcheq?.taxes.interest} />}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 3 : 8} columnWidth={1}>
                        <CustomData
                            titleText="detail.echeq.comission"
                            titleTextType="I18N"
                            valueTextType="TEXT"
                            valueText={<FormattedAmount currency="ARS" quantity={dataEcheq?.taxes.commission} />}
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 3 : 9} columnWidth={1}>
                        <CustomData
                            titleText="detail.echeq.Plazo"
                            titleTextType="I18N"
                            valueTextType="TEXT"
                            valueText={dataEcheq?.taxes.timeLimit}
                        />
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>
        </>
    );
};

DataDetailDiscounts.propTypes = {
    isDesktop: bool.isRequired,
};
export default DataDetailDiscounts;
